"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.errorLabel = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _styleConsts = require("../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color,
      disabled = _ref.disabled,
      error = _ref.error,
      warning = _ref.warning;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;input,textarea{border:1px solid transparent;border-radius:2px;transition:border-color 0.3s;outline:none;opacity:", disabled && '0.5', ";", !disabled && "\n      &:hover {\n        border-color: ".concat(color.grey1, "\n      }\n\n      &:focus {\n        border-color: ").concat(color.accentClicked, ";\n        ").concat(error &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-color:", color.red, ";"), "\n        ").concat(warning &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-color:", color.yellow, ";"), "\n      }\n    "), "}textarea{padding:6px;}")
  );
};

var errorLabel = function errorLabel(error) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;bottom:-24px;left:6px;color:", error ? _themeConfig.default.color.red : _themeConfig.default.color.yellow, ";font-size:", _styleConsts.font.size.medium, ";")
  );
};

exports.errorLabel = errorLabel;

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-17g94270"
})(styles));

exports.default = _default;